import React from "react";
import styled from "@emotion/styled";
import {
  fontSize,
  fontWeight,
  spacing,
  borderRadius,
  border as borderToken,
  surface,
  text,
} from "@atlas-int/tokens";

export interface PreviewSectionProps {
  id: string;
  title: string;
  description?: string;
  dark?: boolean;
  children: React.ReactNode;
}

const Section = styled.section`
  margin-bottom: ${spacing[16]};
  scroll-margin-top: ${spacing[10]};
`;

const SectionTitle = styled.h2`
  font-size: ${fontSize["2xl"]};
  font-weight: ${fontWeight.semibold};
  color: ${text.primary};
  margin: 0 0 ${spacing[2]} 0;
`;

const SectionDescription = styled.p`
  font-size: ${fontSize.base};
  color: ${text.secondary};
  margin: 0 0 ${spacing[8]} 0;
`;

const PreviewContainer = styled.div`
  padding: ${spacing[12]};
  background-color: ${surface.raised};
  border: 1px solid ${borderToken.default};
  border-radius: ${borderRadius.md};
`;

const PreviewSection: React.FC<PreviewSectionProps> = ({ id, title, description, children }) => {
  return (
    <Section id={id}>
      <SectionTitle>{title}</SectionTitle>
      {description && <SectionDescription>{description}</SectionDescription>}
      <PreviewContainer>{children}</PreviewContainer>
    </Section>
  );
};

export default PreviewSection;
